export function isSuperAdminEmail(email: string) {
  return email === 'admin@fourwav.es';
}
